import { render, staticRenderFns } from "./auto-message-template-restrictions-dialog.vue?vue&type=template&id=21bc7dcb&scoped=true&"
import script from "./auto-message-template-restrictions-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-message-template-restrictions-dialog.vue?vue&type=script&lang=js&"
import style0 from "./auto-message-template-restrictions-dialog.vue?vue&type=style&index=0&id=21bc7dcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc7dcb",
  null
  
)

export default component.exports